import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-final-form";
import { Field } from "react-final-form";

import { RenderField } from "../../../commonjs/components";
import { i18n } from "../../../i18next";
import { AutoSave } from "../../../commonjs/components/Autosave";

import {
  useRegistration,
  checkIsRegistrationOfAdditionalUser,
  checkIsKnownCompany,
} from "./useRegistration";
import { TAccountOnly } from "./TAccountOnly";

export const isValidDuns = (duns) => {
  return /^\d{9}$/.test(duns);
};

const validateKnownCompany = (values) => {
  const errors = {};

  if (!(values.name && values.name.length > 0)) {
    errors.name = i18n.t("Required");
  }
  if (
    !(values.vat_identification_no && values.vat_identification_no.length > 0)
  ) {
    errors.vat_identification_no = i18n.t("Required");
  }

  return errors;
};

const validateUnknownCompany = (values) => {
  const errors = validateKnownCompany(values);

  if (values.duns && values.duns.length > 0 && !isValidDuns(values.duns))
    errors.duns = i18n.t("Invalid DUNS");

  return errors;
};
export const RenderCheckboxGroup = ({
  initialValues,
  onChange,
  name,
  options,
  disabled,
  mandatory,
  mandatoryMessage,
}) => {
  const [selectedValues, setSelectedValues] = useState(initialValues || []);

  return (
    <div className="grid__item xs-12 md-12">
      {options.map((option, index) => (
        <div key={index} className={"checkbox grid__item xs-4 md-4"}>
          <input
            type="checkbox"
            className="vertical-spacing-half"
            name={`${name}[${index}]`}
            value={option.name}
            checked={selectedValues.indexOf(option.name) !== -1}
            disabled={disabled}
            onChange={(event) => {
              let newValue = [...selectedValues];
              if (event.target.checked) {
                newValue.push(option.name);
              } else {
                newValue.splice(newValue.indexOf(option.name), 1);
              }
              onChange(newValue);
              setSelectedValues(newValue);
            }}
          />
          <label
            htmlFor={option.name}
            style={{
              display: "inline-block",
              marginLeft: "0.5rem",
              marginTop: "-2.5rem",
              lineHeight: "2rem",
              verticalAlign: "middle",
            }}
          >
            {option.label}
          </label>
        </div>
      ))}
      {!disabled && mandatory && !selectedValues.length > 0 && (
        <div className={"error-checkbox grid__item xs-12 md-12"}>
          {mandatoryMessage}
        </div>
      )}
    </div>
  );
};

// These are already hard-coded in the Backend: We just continue this, as there is no proper structure to get them from somewhere...
const DESTINATION_OPTIONS = [
  "Vesoul (FR)",
  "Bochum (DE)",
  "Rivalta (IT)",
  "Betim (BR)",
  "Other/Autres",
].map((destination) => ({
  label: destination,
  name: destination,
}));

const Destinations = () => {
  const { t } = useTranslation();
  const { setDestinations } = useRegistration((state) => ({
    setDestinations: state.setDestinations,
  }));

  return (
    <div>
      <div className="grid__item xs-12 vertical-spacing">
        <h3>{t("Stellantis Destination/Warehouses")}</h3>
      </div>

      <div>
        <RenderCheckboxGroup
          initialValues={[]}
          options={DESTINATION_OPTIONS}
          name={"destination"}
          disabled={false}
          error={false}
          onChange={(values) => setDestinations(values)}
          mandatory={false}
          mandatoryMessage={t("Choose at least one destination")}
        />
      </div>
    </div>
  );
};
export const CompanyProfile = () => {
  const { t } = useTranslation();
  const {
    company_profile,
    setCompanyProfile,
    isRegistrationOfAdditionalUser,
    isKnownCompany,
  } = useRegistration((state) => ({
    company_profile: state.company_profile,
    setCompanyProfile: state.setCompanyProfile,
    coforMode: state.coforMode,
    isRegistrationOfAdditionalUser: checkIsRegistrationOfAdditionalUser(state),
    isKnownCompany: checkIsKnownCompany(state),
  }));

  return (
    <Form
      // not using submit functionality, data is handled with AutoSave
      onSubmit={() => {}}
      validate={isKnownCompany ? validateKnownCompany : validateUnknownCompany}
    >
      {({ handleSubmit, pristine, submitting }) => (
        <div className="cofor10step">
          <AutoSave
            onValid={(values) => setCompanyProfile(values)}
            onInvalid={() => setCompanyProfile({})}
          />
          <div className="grid__item xs_12 md-12">
            <Field
              name="name"
              placeholder={t("Company Name")}
              disabled={isKnownCompany}
              component={RenderField}
              initialValue={company_profile.name}
              type={"text"}
            />
          </div>
          <div className="grid__item xs_12 md-12">
            <Field
              name="vat_identification_no"
              placeholder={t("VAT or tax number")}
              disabled={isRegistrationOfAdditionalUser}
              component={RenderField}
              initialValue={company_profile.vat_identification_no}
              type={"text"}
            />
          </div>
          <TAccountOnly>
            <div className="grid__item xs_12 md-12">
              <Field
                name="duns"
                placeholder={t("DUNS")}
                disabled={isRegistrationOfAdditionalUser}
                component={RenderField}
                initialValue={company_profile.duns}
                type={"text"}
              />
            </div>

            <Destinations />
          </TAccountOnly>
        </div>
      )}
    </Form>
  );
};
